import { AnimatePresence } from 'framer-motion';
import React from 'react';
import { useCookiesContext } from '../../context';
import { CookiesBanner } from '../CookiesBanner';
import { CookiesPopup } from '../CookiesPopup';

const CookiesWrapper: React.FC = () => {
	const { cookiesSettings } = useCookiesContext();
	const { banner, popup } = cookiesSettings;

	return (
		<>
			<AnimatePresence>{banner ? <CookiesBanner /> : null}</AnimatePresence>

			<AnimatePresence>{popup ? <CookiesPopup /> : null}</AnimatePresence>
		</>
	);
};

export default CookiesWrapper;
